import React, { useState, useEffect } from "react";
import { Label, Badge, Col, Card, CardBody, Row, Button } from 'reactstrap';
// import { Button } from 'semantic-ui-react';

import StepperEvent from './../../../Components/StepperEvent';
import ContainerInformation from './ContainerInformation'
import IncidentInformation from './IncidentInformation'
import Form from './Form'


function Summary(props) {
	const [update, setupdate] = useState(false)
	const [updateIncident, setupdateIncident] = useState(true)
	const [editForm] = useState({ ...Form })

	function UpdateContainer() {
		setupdate(!update);
		if (update === true) {
			editForm.General[13].type = 'date'
			editForm.General[14].type = 'date'
			editForm.General[15].type = 'date'
			props.Model['PortTerminal'].hidden = true
			props.Model['PortTerminalId'].hidden = false
		}
		else {
			editForm.General[13].type = 'info'
			editForm.General[14].type = 'info'
			editForm.General[15].type = 'info'
			props.Model['PortTerminal'].hidden = false
			props.Model['PortTerminalId'].hidden = true
		}
	}


	useEffect(() => {
		UpdateContainer()
	}, [])

	function DisabledUpdateInciden() {
		setupdateIncident(!updateIncident);
		if (updateIncident === true) {
			props.Model['incidenttype'].hidden = false
			props.Model['incidenttypeId'].hidden = true
			editForm.Incident[2].type = 'date'
			editForm.Incident[3].type = 'text-area'
		}
		else {
			props.Model['incidenttype'].hidden = true
			props.Model['incidenttypeId'].hidden = false
			editForm.Incident[2].type = 'info'
			editForm.Incident[3].type = 'info'
		}
	}

	return (
		<div className="content">
			<Col xs={12} style={{ textAlign: 'right', }}>
				<CardBody>
					{
						update ?
							<Button
								color="primary"
								onClick={UpdateContainer}
							>
								<i className='fas fa-edit mr-2' />
								Update
							</Button >
							:
							<div>
								<Button
									color="danger"
									onClick={() => { props.ContainerId(props.Model.ContainerId.value); UpdateContainer() }}
								>
									<i className='fas fa-window-close mr-2' />
									Cancel
								</Button>
								&nbsp;
								&nbsp;
								&nbsp;
								<Button
									color="primary"
									onClick={() => { props.UpdateContainer(); UpdateContainer() }}
								>
									<i className='fas fa-plus-circle mr-2' />
									Save
								</Button>
							</div>
					}
				</CardBody>
			</Col>
			<Card className='myCard'>
				<Col xs={12}>
					<CardBody>
						<Row>
							<Col xs={3}>
								<Label>
									<b>Shipment No.: </b> {props.dataContainer.ShipmentNumber}
								</Label>
							</Col>
							<Col xs={2} className='d-flex align-items-center' >
								<i className='fas fa-user-alt mr-2' style={{ fontSize: '1.6em', color: `${props.dataContainer.statuscustomercolor}` }} />
								<Badge style={{ width: '100%', backgroundColor: `${props.dataContainer.statuscustomercolor}`, padding: '0.4em' }}>
									{props.dataContainer.statuscustomer}
								</Badge>
							</Col>
							<Col xs={2} className='d-flex align-items-center' >
								<i className='fas fa-ship mr-2' style={{ fontSize: '1.6em', color: `${props.dataContainer.statuscarriercolor}` }} />
								<Badge style={{ width: '100%', backgroundColor: `${props.dataContainer.statuscarriercolor}`, padding: '0.4em' }}>
									{props.dataContainer.statuscarrier}
								</Badge>
							</Col>
						</Row>
						<Row>
							<Col xs={3}>
								<Label>
									<b>Container No.: </b> {props.dataContainer.NoContainer}
								</Label>
							</Col>
						</Row>
						<Row>
							<Col xs={3}>
								<Label>
									<b>Customer: </b>{props.dataContainer.Customer}
								</Label>
							</Col>
						</Row>
					</CardBody>
				</Col>
				<Col xs={12}>
					<StepperEvent steps={props.steps} dataEvents={props.dataEvents} />
				</Col>
			</Card >
			<Col>
				<Row>
					<Col xs={9} style={{ padding: "0px 15px 15px 0px" }}>
						<ContainerInformation Model={props.Model} Catalog={props.Catalog} onChange={props.onChange} />
					</Col>
					<Col xs={3} style={{ padding: "0px 15px 15px 0px" }}>
						<IncidentInformation
							Model={props.Model}
							Catalog={props.Catalog}
							onChange={props.onChange}
							onCancel={props.onCancel}
							CreateIncident={props.CreateIncident}
							DeleteIncidencia={props.DeleteIncidencia}
							DisabledUpdateInciden={DisabledUpdateInciden}
							UpdateIncident={props.UpdateIncident}
							flag={updateIncident}
						/>
					</Col>
				</Row>
			</Col>
		</div>
	);
}
export default Summary;